import { motion } from 'framer-motion';
import { fadeUp, stagger } from './motionPresets';

const benefits = [
  { icon: '/icon-avoid-penalties.svg', title: 'Avoid DOL Penalties', desc: 'Ensure every PAF meets Department of Labor requirements before an audit happens.' },
  { icon: '/icon-stay-audit.svg', title: 'Stay Audit-Ready', desc: 'One-click public access file generation with complete document checklists.' },
  { icon: '/icon-reduce-tracking.svg', title: 'Reduce Manual Tracking', desc: 'Replace spreadsheets with automated compliance tracking and deadline alerts.' },
  { icon: '/icon-hr-efficiency.svg', title: 'Improve HR Efficiency', desc: 'Save 10+ hours per week with centralized document management and reporting.' },
];

const complianceBars = [
  { label: 'LCA Documentation', pct: 100, color: '#10B981' },
  { label: 'Wage Records', pct: 100, color: '#10B981' },
  { label: 'Employee Notification', pct: 75, color: '#F59E0B' },
  { label: 'Benefits Summary', pct: 0, color: '#EF4444' },
];

export default function BenefitsSection() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div {...fadeUp} transition={{ duration: 0.5 }}>
            <p className="text-sm font-semibold text-indigo-600 uppercase tracking-wider mb-3">Why PAFHub</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-6">Built for compliance peace of mind</h2>
            <p className="text-lg text-[#64748B] leading-relaxed mb-10">Stop worrying about DOL audits. PAFHub ensures your organization is always compliant and audit-ready.</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {benefits.map((b, i) => (
                <motion.div key={b.title} {...stagger} transition={{ duration: 0.4, delay: i * 0.1 }}>
                  <div className="mb-3">
                    <img src={b.icon} alt={b.title} className="w-14 h-14" />
                  </div>
                  <h4 className="text-sm font-bold text-[#0F172A] mb-1">{b.title}</h4>
                  <p className="text-sm text-[#64748B] leading-relaxed">{b.desc}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Visual */}
          <motion.div {...fadeUp} transition={{ duration: 0.6, delay: 0.2 }} className="relative">
            <div className="bg-gradient-to-br from-indigo-600 to-indigo-800 rounded-3xl p-8 lg:p-10 text-white">
              <h3 className="text-2xl font-bold mb-8 tracking-tight">Compliance at a glance</h3>
              <div className="space-y-4">
                {complianceBars.map((item) => (
                  <div key={item.label}>
                    <div className="flex items-center justify-between mb-1.5">
                      <span className="text-sm text-indigo-100">{item.label}</span>
                      <span className="text-sm font-semibold">{item.pct}%</span>
                    </div>
                    <div className="h-2 bg-white/10 rounded-full overflow-hidden">
                      <div className="h-full rounded-full transition-all" style={{ width: `${item.pct}%`, backgroundColor: item.color }} />
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 p-4 bg-white/10 rounded-xl backdrop-blur-sm">
                <div className="flex items-center justify-between">
                  <span className="text-sm text-indigo-100">Overall Compliance</span>
                  <span className="text-2xl font-bold">68.75%</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
